import type { InfiniteData, QueryClient } from '@tanstack/react-query';

import { FEED_VIEW_DEFAULT } from '~/constants/community';
import type { CommunityPost } from '~/interfaces/community';

import { type CommunityPostsPage, communityPostsKeys } from '../_hooks/useCommunityPosts';

const prependPost =
  (post: CommunityPost) =>
  (oldData?: InfiniteData<CommunityPostsPage>): InfiniteData<CommunityPostsPage> | undefined => {
    if (!oldData || oldData.pages.length === 0) return oldData;
    const [firstPage, ...restPages] = oldData.pages;
    return {
      ...oldData,
      pages: [{ ...firstPage, posts: [post, ...firstPage.posts] }, ...restPages],
    };
  };

export const createdPostFeedQueryKeys = (post: CommunityPost) => {
  const globalKey = communityPostsKeys.feed(undefined, FEED_VIEW_DEFAULT);
  const slug = post.space?.slug;
  if (!slug) return [globalKey];
  return [communityPostsKeys.feed(slug, FEED_VIEW_DEFAULT), globalKey];
};

export const insertCreatedPostIntoFeedCaches = (queryClient: QueryClient, post: CommunityPost) => {
  const update = prependPost(post);
  const keys = createdPostFeedQueryKeys(post);

  for (const queryKey of keys) {
    queryClient.setQueryData(queryKey, update);
    void queryClient.invalidateQueries({ queryKey, refetchType: 'none' });
  }
};
